import React, { useState } from 'react';

import type { InputProps } from '../Input';
import Input from '../Input';
import Visibility from './visibility.svg?react';
import VisibilityOff from './visibilityOff.svg?react';

const InputPassword: React.FC<InputProps> = props => {
    const [type, setType] = useState('password');

    const toggleType = () => {
        setType(type === 'password' ? 'text' : 'password');
    };

    const EndAdornment = () => (
        <button onClick={toggleType}>{type === 'password' ? <Visibility /> : <VisibilityOff />}</button>
    );

    return <Input {...props} type={type} endAdornment={<EndAdornment />} />;
};

export default InputPassword;
